<template>
	<PageHeaderLayout>
		<div class="main-page-content">
			<div class="payment-notice">
				<div class="notice-content">
					<i class="el-icon-warning-outline notice-icon"></i>
					<h2 class="notice-title">当前页面需付费使用</h2>
					<p class="notice-text">请联系管理员开通权限</p>
				</div>
			</div>
		</div>
	</PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";

export default {
	components: {
		PageHeaderLayout,
	},
};
</script>

<style lang="scss" scoped>
.payment-notice {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 600px;
	padding: 40px 20px;
}

.notice-content {
	text-align: center;
	max-width: 500px;
}

.notice-icon {
	font-size: 80px;
	color: #e6a23c;
	margin-bottom: 24px;
}

.notice-title {
	font-size: 24px;
	font-weight: 600;
	color: #303133;
	margin: 0 0 16px 0;
}

.notice-text {
	font-size: 16px;
	color: #606266;
	margin: 0;
	line-height: 1.6;
}
</style>
